import { authRules, IAuthPermission } from "./authRules";

export const isAuthorized = (action: string, role: string): IAuthPermission => {
  if (role) {
    const ret = authRules[role][action];
    return ret;
  }
  return { disabled: true, hidden: true };
};
